export default [
  'warnerbros.com',
  'wmcontractor.com',
  'disney.com',
  'fox.com',
  'nbcuni.com',
];
